import * as dotenv from 'dotenv' 
dotenv.config()
import Vue from "vue";
import App from "./App.vue";
import Argon from "./plugins/argon-kit";
import VueTheMask from 'vue-the-mask'
import { VBPopoverPlugin } from 'bootstrap-vue'
import { TooltipPlugin } from 'bootstrap-vue'
import { getSiteTheme } from "./services/theme"
import Money from 'v-money'
import router from './router'

Vue.config.productionTip = false
Vue.use(Argon);
Vue.use(VueTheMask)
Vue.use(VBPopoverPlugin)
Vue.use(TooltipPlugin)
Vue.use(Money, {precision: 4})
Vue.socket = null;
Vue.product = 'loanportal'

Vue.prototype.$theme = {
  logo: {
    light: `https://proistatic.com/shared/loanportal/img/brand/loanPortalLogo-light.svg`,
    dark: `https://proistatic.com/shared/loanportal/img/brand/loanPortalLogo-dark.svg`
  },
  icons: {
    favicon: "https://proistatic.com/shared/loanportal/favicon.ico",
    icon: "https://proistatic.com/shared/loanportal/img/brand/loanPortal_icon.svg"
  },
  description: "The Loan Portal provides a fast and intuitive way to walk your customers through the loan process.",
  title: "Loan Portal",
  default: "rgba(23, 43, 77, 1)",
  defaultLight: "rgba(23, 43, 77, .3)",
  primary: "rgba(94, 114, 228, 1)",
  primaryLight: "rgba(94, 114, 228, .3)",
  success: "rgba(45, 206, 137, 1)",
  successLight: "rgba(45, 206, 137, .3)",
  danger: "rgba(245, 54, 92, 1)",
  dangerLight: "rgba(245, 54, 92, .3)",
  warning: "rgba(251, 99, 64, 1)",
  warningLight: "rgba(251, 99, 64, .3)",
  info: "rgba(17, 205, 239, 1)",
  infoLight: "rgba(17, 205, 239, .3)",
  background: "#ffffff",
  fontColor: "rgba(50, 50, 93, 1)",
  fontColorLight: "rgb(136, 152, 170)"
};

const getTheme = async () => {

  await getSiteTheme();
}

getTheme();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')